import React from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";

const TableComponent = ({ data, permission, theme, title, ref, column, notInvolved, onCellClicked }) => {

    if (!permission) return null;
    return (
        <Card className={"mt-2"}>
            <Card.Header>
                <Card.Title className={"flex justify-between"}>{title}</Card.Title>
            </Card.Header>
            <Card.Body>
                {
                    data.length > 0 ?
                        <div className="flex">
                            <div className="w-full p-0 ag-theme-quartz aggrid-row-pointer">
                                <AgGridReact
                                    ref={ref}
                                    rowData={data ?? []}
                                    columnDefs={column}
                                    animateRows={false}
                                    suppressCellFocus
                                    domLayout='autoHeight'
                                    onCellClicked={onCellClicked}
                                    gridOptions={{ localeText: aggridUtils.localization() }}
                                    theme={theme}
                                />
                            </div>
                        </div>
                        :
                        <div className="flex font-bold p-4 justify-center items-center rounded-sm w-[99%] h-[40px] mx-auto data-not-found
                               text-[#1C6EAF] bg-[#A7D4FF]" >
                            {notInvolved}
                        </div>
                }

            </Card.Body>
        </Card>
    );
};

export default TableComponent;